import {operate} from '../../../utils/config'
import store from '../../../utils/store'
import {getFun,postFun} from '../../../utils/httpFun'

// 主要banner类
class Banner{
  constructor(name,applicationType,belongToPlatform) {
    this.homeThis = '';
    this.name = name;
    this.applicationType = applicationType;
    this.belongToPlatform = belongToPlatform;
    this.param = {};

    this.defaultNum = 0;

    // 获取bann的信息
    this.bannInfo = [];
    // 获取banner的位置id
    this.blId = '';
    // 获取banner的位置name
    this.bannerName = '';

    // 增加的参数
    this.addParam = {
      title:'',
      linkUrl:'',
      priority:0,
      resource:''
    }

    this.domMessage = {
      width:0,
      height:0
    }

    this.setMethodThis(['getImgMessage','getImg','addBanner']);
  }

  // 重置默认值
  setDefault(){
    // this.bannInfo = [];
    // this.blId = '';
    // this.bannerName = '';
    this.addParam.title = '';
    this.addParam.linkUrl = '';
    this.addParam.priority = this.defaultNum;
    this.addParam.resource = '';
    this.domMessage.width = 0;
    this.domMessage.height = 0;
  }

  // 获取this
  setHomeThis(res){
    this.homeThis = res;
  }

  // 删除Banner
  delBanner(item,_this){
    if(_this.$refs.tableData.getTableData().length == 1){
      console.log('==========')
      _this.$message.warning('最少保留一条');
      return true;
    }
    postFun(operate.DELETEBANNERDETAILS+"?id="+item.id,{
      // id:item.id
    },res=>{
      if(res.data)
        this.homeThis.$message.success('删除成功');
      else
        this.homeThis.$message.warning('删除失败');
    }) 
  }

  // 编辑Banner
  editBanner(_this,item){
    if(!!!this.addParam.title){
      this.homeThis.$message.warning('标题不能为空');
      return;
    }
    if(!!!this.addParam.resource || this.addParam.resource.length == 0){
      this.homeThis.$message.warning('请上传图片');
      return;
    }

    let param = {
      ...this.addParam,
      id:item.id,
      blId:this.blId,
      height:this.domMessage.height,
      width:this.domMessage.width
    }

    postFun(operate.UPDATEBANNERDETAILS,param,res=>{
      console.log('编辑',res);
      if(res.data)
        this.homeThis.$message.success('编辑成功');
      else
        this.homeThis.$message.warning('编辑失败');

      _this.$parent.getList();
      _this.closedBtn();
    })
  }

  // 增加banner
  addBanner(_this,callback){

    console.log('this',this.addParam,this.blId,this.domMessage)
    if(!!!this.addParam.title){
      this.homeThis.$message.warning('标题不能为空');
      return;
    }
    if(!!!this.addParam.resource || this.addParam.resource.length == 0){
      this.homeThis.$message.warning('请上传图片');
      return;
    }

    let param = {
      ...this.addParam,
      blId:this.blId,
      height:this.domMessage.height,
      width:this.domMessage.width,
      operator:store.state.operator
    }

    postFun(operate.ADDBANNERDETAILS,param,res=>{
      console.log('增加',res);
      if(res.data)
        this.homeThis.$message.success('增加成功');
      else
        this.homeThis.$message.warning('增加失败');

      _this.$parent.getList();
      setTimeout(() => {
        _this.closedBtn();
      }, 500);
    })
  }

  // 切换侧边栏
  cutSidebar(item,_this){
    this.blId = item.id;
    this.bannerName = item.location;
    this.applicationType = item.applicationType;
    this.belongToPlatform = item.belongToPlatform;

    this.getBannerDetailsList(_this);
  }

  // 获取上传的图片
  getImg(file){
    console.log('fef======',file)
    this.addParam.resource = file.val[0];
    console.log('aaa',this.addParam)
  }

  // 设置方法this
  setMethodThis(methodArr){
    methodArr.forEach(item=>{
     this[item] = this[item].bind(this);
    })
  }

  // 获取图片信息
  getImgMessage(file){
    console.log('图片信息',file);
    let reader = new FileReader();
    reader.onload = (event) => {
        let txt = event.target.result;
        let img = document.createElement("img");
        img.src = txt;
        img.onload = ()=>{
            this.domMessage.width = img.width;
            this.domMessage.height = img.height;
            console.log('图片宽度',img.width);
            console.log('图片高度',img.height);
        }
    };
    reader.readAsDataURL(file);
  }

  // 获取banner分页
  getBannerDetailsList(_this){
    console.log('查询分页',this.blId);
    _this.param.blId = this.blId;
    _this.$refs.tableData.getDatas()
   _this.$nextTick(()=>{
      setTimeout(()=>{
          let tableArr = _this.$refs.tableData.getTableData();
          console.log('数据',tableArr)
          this.addParam.priority = tableArr[tableArr.length - 1].priority+1 || 1; 
          this.defaultNum = this.addParam.priority;
      },500)
    })
  }

  // 获取Banner类型 bannner位置
  getBannerLayoutList(isOne = true){
    let param = {
      "applicationType": this.applicationType,
	    "belongToPlatform": this.belongToPlatform
    };

  postFun(operate.GETBANNERLAYOUTLIST,param,res=>{
      console.log('查询banner类型',res);

      // 目前没有登陆 所以先过滤登陆
      let list = res.data.filter(item=>item.code != 'login')

      this.bannInfo = list;

      console.log('============',this.bannInfo)
      if(isOne){
        this.blId = this.bannInfo[0].id;
        this.bannerName = this.bannInfo[0].location;
      }
      return new Promise(resolve=>{resolve('请求成功')});
    })
  }
}

export class Controller {
  constructor(){
  }

  static getObject(index){
    this.index = index;

    switch(this.index){
      case 1:
        // 运维pc
        return new OperBanner(1,1);
      break;
      case 2:
        // 工厂pc
        return new FactoryBanner(1,2);
      break;
      case 3:
        // 代理pc
        return new AgentBanner(1,3);
      break;
      case 4:
        // 工程商安装小程序
        return new AgentBanner(3,4);
      break;
      case 5:
        // 工厂APP
        return new FactoryApp(2,2);
      break;
      case 6:
        // 代理商APP
        return new AgentApp(2,3);
      break;
    }
  }
}

// 运维banner
export class OperBanner extends Banner{
  constructor(applicationType,belongToPlatform){
    super('运维管理web',applicationType,belongToPlatform);
  }
}

// 工厂banner
export class FactoryBanner extends Banner {
  constructor(applicationType,belongToPlatform){
    super('工厂端web',applicationType,belongToPlatform);
  }
}

// 代理商banner
export class AgentBanner extends Banner {
  constructor(applicationType,belongToPlatform){
    super('代理商web',applicationType,belongToPlatform);
  }
}

// 安装小程序banner
export class AppletBanner extends Banner {
  constructor(applicationType,belongToPlatform){
    super('安装小程序',applicationType,belongToPlatform);
  }
}

// 工厂App banner
export class FactoryApp extends Banner {
  constructor(applicationType,belongToPlatform){
    super('工厂App',applicationType,belongToPlatform);
  }
}

// 代理App banner
export class AgentApp extends Banner {
  constructor(applicationType,belongToPlatform){
    super('代理App',applicationType,belongToPlatform)
  }
}